import { render, staticRenderFns } from "./InsurerForm.vue?vue&type=template&id=aef21334&"
import script from "./InsurerForm.vue?vue&type=script&lang=ts&"
export * from "./InsurerForm.vue?vue&type=script&lang=ts&"
import style0 from "./InsurerForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCardText,VDivider,VForm})
